"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleView_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var Location_1 = require("./Location");
var RecordStatus_1 = require("./RecordStatus");
var ScheduleViewChair_1 = require("./ScheduleViewChair");
var User_1 = require("./User");
var ScheduleView_Factory = /** @class */ (function () {
    function ScheduleView_Factory() {
    }
    ScheduleView_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Location: Location_1.Location_Factory.CreateIncoming(model.Location),
            LocationId: model.LocationId,
            OwnerId: model.OwnerId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            RecordStatus1: RecordStatus_1.RecordStatus_Factory.CreateIncoming(model.RecordStatus1),
            ScheduleViewChairs: model.ScheduleViewChairs && model.ScheduleViewChairs.map(function (i) { return ScheduleViewChair_1.ScheduleViewChair_Factory.CreateIncoming(i); }),
            User: User_1.User_Factory.CreateIncoming(model.User),
            ViewName: model.ViewName,
        };
        return result;
    };
    ScheduleView_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Location: Location_1.Location_Factory.CreateOutgoing(model.Location),
            LocationId: model.LocationId,
            OwnerId: model.OwnerId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            RecordStatus1: RecordStatus_1.RecordStatus_Factory.CreateOutgoing(model.RecordStatus1),
            ScheduleViewChairs: model.ScheduleViewChairs && model.ScheduleViewChairs.map(function (i) { return ScheduleViewChair_1.ScheduleViewChair_Factory.CreateOutgoing(i); }),
            User: User_1.User_Factory.CreateOutgoing(model.User),
            ViewName: model.ViewName,
        };
        return result;
    };
    return ScheduleView_Factory;
}());
exports.ScheduleView_Factory = ScheduleView_Factory;
